<template>
  <div class="p-documents">
    <page-title>File Management</page-title>

    <section-block>
      <template slot="header">
        <filter-bar resource="files" show-search></filter-bar>
      </template>

      <template slot="actions">
        <base-button
          :primary="true"
          iconBefore="upload"
          @click="onAddClick"
          type="button"
        >Add New File</base-button>
      </template>
      <vuetable
        v-if="!loading && files"
        class="c-data-table"
        :api-mode="false"
        :fields="table.fields"
        :data-manager="dataManager"
        pagination-path
        ref="filesTable"
        @vuetable:pagination-data="onPaginationData"
      >
        <template slot="name" slot-scope="props">
          <div class="c-data-table__cell-icon">
            <file-icon :type="props.rowData.name|extension"></file-icon>
            <span>{{props.rowData.name}}</span>
          </div>
        </template>

        <template slot="date-created" slot-scope="props">
          <base-datetime :date="props.rowData.created_time"></base-datetime>
        </template>
      </vuetable>
      <pagination table-pagination>
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </pagination>
    </section-block>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FileActions from "@/components/FileActions";
import Pagination from "@/components/pagination";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";

export default {
  components: {
    FileActions,
    Pagination,
    VuetablePagination
  },
  methods: {
    onRowClick(dataItem) {
      this.$router.push({
        name: "AdminFilesView",
        params: { id: dataItem.data.id }
      });
    },
    onAddClick() {
      this.$router.push({
        name: "AdminFilesCreate"
      });
    },
    onEditClick(dataItem) {
      this.$router.push({
        name: "AdminFilesEdit",
        params: { id: dataItem.data.id }
      });
    },
    updateTable() {
      this.$refs.filesTable.refresh();
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.files.pagination,
        data: this.files
      };

      console.log(returnObj);

      return returnObj;
    },
    onPaginationData(paginationData) {
      console.log("paginate", paginationData);
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.filesTable;
      let nextPage;
      this.loading = true;

      switch (page) {
        case "next":
          nextPage = ++this.$store.state.files.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.files.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.$store.dispatch("files/list", { page: nextPage }).then(resp => {
        window.scroll(0, 0);
        tableref.changePage(nextPage);
        this.loading = false;
      });
    }
  },
  data() {
    return {
      loading: true,
      table: {
        fields: [
          {
            name: "name",
            title: "File Name",
            titleClass: "u-ta-left",
            dataClass: "u-ta-left title-col",
            width: "35%"
          },
          {
            name: "date-created",
            title: "Date Added",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "15%"
          },
          {
            name: FileActions,
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%"
          }
        ]
      }
    };
  },

  watch: {
    files(newValue, oldValue) {
      if (this.$refs.filesTable) {
        this.$refs.filesTable.refresh();
      }
    }
  },

  computed: {
    ...mapState("files", ["files"])
  },

  created() {
    this.$store.dispatch("files/list").then(resp => {
      this.loading = false;
    });
  }
};
</script>

<style scoped>
</style>